import React from 'react'
import { BsEye } from 'react-icons/bs';
import { CiSearch } from 'react-icons/ci';
import { FaCircle } from 'react-icons/fa';
import NavigationButtons from '../../../components/NavigationButtons';
import { useNavigate } from 'react-router';

const AllActivities = () => {
    const navigate = useNavigate();
    const submissionData = [
        {
            "Supervisor Name": "Ahmed Ali",
            "Student Name": "John Doe",
            "Subject Name": "English",
            "Topic Name": "Essay Writing",
            "Status": "Completed",
            "Start Date": "Jan 08, 2025",
            "End Date": "Jan 18, 2025",
            "Options": "View Details"
        },
        {
            "Supervisor Name": "Sara Khan",
            "Student Name": "Emma Watson",
            "Subject Name": "Mathematics",
            "Topic Name": "Algebra Basics",
            "Status": "In-Progress",
            "Start Date": "Feb 12, 2025",
            "End Date": "Feb 22, 2025",
            "Options": "View Details"
        },
        {
            "Supervisor Name": "Michael Smith",
            "Student Name": "David Lee",
            "Subject Name": "Science",
            "Topic Name": "Physics Experiments",
            "Status": "Pending",
            "Start Date": "Mar 15, 2025",
            "End Date": "Mar 25, 2025",
            "Options": "View Details"
        },
        {
            "Supervisor Name": "Fatima Noor",
            "Student Name": "Sophia Jones",
            "Subject Name": "History",
            "Topic Name": "World War II",
            "Status": "Completed",
            "Start Date": "Apr 05, 2025",
            "End Date": "Apr 15, 2025",
            "Options": "View Details"
        },
        {
            "Supervisor Name": "James Brown",
            "Student Name": "Olivia Patel",
            "Subject Name": "Geography",
            "Topic Name": "Climate Change",
            "Status": "In-Progress",
            "Start Date": "May 10, 2025",
            "End Date": "May 20, 2025",
            "Options": "View Details"
        }
    ]

    return (
        <div className='p-8 space-y-4 mt-8'>
            <div className="bg-white border-gray-400 rounded-lg border w-full  relative p-4 ">
                <p className="absolute bg-white text-2xl font-medium -top-8 left-8 p-2">
                    Submission Details
                </p>
                <div className="overflow-x-auto">
                    <table className="w-full ">
                        <thead className="text-[16px] font-medium">
                            <tr>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    Supervisor Name
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    Student Name
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    Subject Name
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    Topic Name
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    Status
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    Start Date
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    End Date
                                </th>
                                <th className="px-4 py-3 text-center text-gray-700 font-semibold">
                                    Options
                                </th>
                            </tr>
                            <tr>
                                <th  className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    <div className="relative w-[130px]">
                                        <input
                                            type="text"
                                            className="border rounded-lg p-1 w-full pr-8"
                                            placeholder="Search..."
                                        />
                                        <CiSearch className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500" />
                                    </div>
                                </th>
                                <th  className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    <div className="relative w-[130px]">
                                        <input
                                            type="text"
                                            className="border rounded-lg p-1 w-full pr-8"
                                            placeholder="Search..."
                                        />
                                        <CiSearch className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500" />
                                    </div>
                                </th>
                                <th  className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    <div className="relative w-[130px]">
                                        <input
                                            type="text"
                                            className="border rounded-lg p-1 w-full pr-8"
                                            placeholder="Search..."
                                        />
                                        <CiSearch className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500" />
                                    </div>
                                </th>
                                <th  className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    <div className="relative w-[130px]">
                                        <input
                                            type="text"
                                            className="border rounded-lg p-1 w-full pr-8"
                                            placeholder="Search..."
                                        />
                                        <CiSearch className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500" />
                                    </div>
                                </th>
                                <th  className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    <div className="relative w-[130px]">
                                        <input
                                            type="text"
                                            className="border rounded-lg p-1 w-full pr-8"
                                            placeholder="Search..."
                                        />
                                        <CiSearch className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500" />
                                    </div>
                                </th>
                                <th  className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    <div className="relative w-[130px]">
                                        <input
                                            type="text"
                                            className="border rounded-lg p-1 w-full pr-8"
                                            placeholder="Search..."
                                        />
                                        <CiSearch className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500" />
                                    </div>
                                </th>
                                <th  className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    <div className="relative w-[130px]">
                                        <input
                                            type="text"
                                            className="border rounded-lg p-1 w-full pr-8"
                                            placeholder="Search..."
                                        />
                                        <CiSearch className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500" />
                                    </div>
                                </th>
                                <th  className="px-4 py-3 text-left text-gray-700 font-semibold">
                                    <div className="relative w-[130px]">
                                        <input
                                            type="text"
                                            className="border rounded-lg p-1 w-full pr-8"
                                            placeholder="Search..."
                                        />
                                        <CiSearch className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500" />
                                    </div>
                                </th>

                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-400">
                            {submissionData.map((submission, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                    <td className="px-4 py-3 whitespace-nowrap">
                                        {submission['Subject Name']}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap">
                                        {submission['Student Name']}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap">
                                        {submission['Subject Name']}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap">
                                        {submission['Topic Name']}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap">
                                        <span className={`w-[100px] h-[30px] rounded-lg flex items-center justify-center  gap-1 text-sm ${submission.status === 'Completed' ? 'bg-blue-200' : 'bg-gray-200'}`}>
                                            <FaCircle className={` h-3 w-3 ${submission.Status === 'Completed' ? 'text-green-400' : 'text-gray-400'}`} />
                                            {submission.Status}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap">
                                        {submission['Start Date']}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap">
                                        {submission['End Date']}
                                    </td>
                                    <td className="py-3 -px-5 whitespace-nowrap  flex justify-center items-center">
                                        <button onClick={() => navigate("/section-head/in-progress-activities")} className="flex items-center justify-center gap-1 bg-blue-600 text-white px-3 py-1 rounded-lg text-sm">
                                            <BsEye />
                                            View Details
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <NavigationButtons dashboardLink='/section-head/dashboard' />
        </div>
    )
}

export default AllActivities